import request from '@/service/request'

export type SensitiveOptType = 'DETAIL' | 'LIST' | 'SENDER' | 'RECEIVER'

export interface SensitiveDecryptRequest {
  key: string | number
  code: string
  path: string
  menuName: string
  optType: SensitiveOptType
  /** 兼容旧协议，不作为菜单授权依据 */
  menuCode?: string
}

export default class getPhoneService {
  /**
   * 获取加密手机号
   * @param data
   * @param data.key
   * @param data.code  code=001 查寄件手机号 002收件手机号 003 下单人手机号
   * @param data.path  当前页面路由的 path
   **/
  static getPhone(data: SensitiveDecryptRequest): Promise<any> {
    return request.post('/sensitive/decrypt', data)
  }
}
